import styled from "styled-components";

export const RateTableStyled = styled.div`
  padding: 12px 36px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  .buttonContainer {
    display: flex;
    justify-content: end;
  }

  .default-pill {
    display: inline-block;
    background-color: #daf0d8 !important;
    color: #2e7d32;
    border-radius: 12px;
    padding: 2px 8px;
  }
`;
